export default "__VITE_ASSET__B45nCggu__"